import { useState } from 'react';
import { Numpad } from './Numpad';
import { PRODUCTOS } from '../constants/productos';
import { fmtMoney } from '../utils/money';

const fmtQty = (qty) => qty % 1 !== 0 ? qty.toFixed(1) : String(qty);

export function ProductGrid({ quantities, onQuantityChange, precios, readOnly = false }) {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [tempValue, setTempValue] = useState(0);

  const handleProductClick = (producto) => {
    if (readOnly) return;
    setSelectedProduct(producto);
    setTempValue(quantities[producto.clave] || 0);
  };

  const handleConfirm = (value) => {
    if (selectedProduct) {
      onQuantityChange(selectedProduct.clave, value);
      setSelectedProduct(null);
    }
  };

  const handleCancel = () => {
    setSelectedProduct(null);
  };

  return (
    <>
      <div className="grid grid-cols-3 gap-3" data-testid="product-grid">
        {PRODUCTOS.map((producto) => {
          const qty = quantities[producto.clave] || 0;
          const precio = precios?.[producto.clave] || 0;

          return (
            <button
              key={producto.clave}
              onClick={() => handleProductClick(producto)}
              className={`product-card ${qty > 0 ? 'selected' : ''} ${readOnly ? 'cursor-default' : ''}`}
              data-testid={`product-${producto.clave}`}
              disabled={readOnly}
            >
              <span className="text-3xl mb-1" role="img" aria-label={producto.nombre}>
                {producto.icon}
              </span>
              <span className="text-sm font-bold text-zinc-900 text-center leading-tight">
                {producto.nombre}
              </span>
              {qty > 0 && (
                <span className="mt-1 px-3 py-1 bg-blue-600 text-white rounded-full text-lg font-bold min-w-[2.5rem] text-center">
                  {fmtQty(qty)}
                </span>
              )}
              {precio > 0 && (
                <span className="text-xs text-zinc-500 mt-1">
                  {fmtMoney(precio)}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {selectedProduct && (
        <Numpad
          value={tempValue}
          onChange={setTempValue}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          title={selectedProduct.nombre}
          subtitle="Ingresa la cantidad"
          allowHalf={selectedProduct.allowHalf || false}
        />
      )}
    </>
  );
}

export { PRODUCTOS };
